export default {
    entityKey: 'organizationAccounts',
    titles: {
        singular: 'Organization Account',
        plural: 'Organization Accounts'
    }
}